import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';

const Hero = () => {
  const theme = useTheme();

  return (
    <Box
      minHeight={{ xs: 'auto', md: 'calc(100vh - 64px)' }}
      height="auto"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundImage:
          'linear-gradient(135deg, rgba(0,0,0,0.82) 0%, rgba(55,40,28,0.92) 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&:after': {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          content: '" "',
          zIndex: 1,
          backgroundColor: theme.palette.primary.dark,
          opacity: 0.72,
        },
      }}
    >
      <Box position="relative" zIndex={2} width="100%">
        <Container>
          <Box textAlign="center" color="common.white">
            <Box
              sx={{
                backgroundImage: 'url(/images/logos/logo_white.PNG)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                height: { xs: 80, md: 120 },
                maxWidth: 320,
                mx: 'auto',
                mb: 3,
              }}
            />
            <Box
              component="img"
              src="/images/expo-mascotas-paw.svg"
              alt="Ícono de patica de perro"
              sx={{
                width: { xs: 64, md: 84 },
                height: { xs: 64, md: 84 },
                mx: 'auto',
                mb: 2,
                display: 'block',
              }}
            />
            <Typography
              sx={{ textTransform: 'uppercase', fontWeight: 600, letterSpacing: 1 }}
              variant="overline"
              display="block"
              gutterBottom
            >
              Propuesta de Cobertura 360
            </Typography>
            <Typography variant="h2" fontWeight={900} gutterBottom align="center">
              Expo Mascotas
              <br />
              Caracas
            </Typography>
            <Typography
              variant="h6"
              component="p"
              align="center"
              sx={{ fontWeight: 400, opacity: 0.95 }}
            >
              TNO Network x Pedro con las Mascotas
            </Typography>
            <Typography
              variant="body1"
              align="center"
              sx={{ mt: 2, opacity: 0.9, maxWidth: 700, mx: 'auto' }}
            >
              Dos días para conectar con quienes amamos. Una cobertura emocional,
              profesional y multiplataforma con Pedro Scutaro como host oficial de
              la experiencia.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Hero;
